// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M2 2H22V22L2 22V2ZM4 4V20L20 20V4H4ZM6.5 11L17.5 11V13L6.5 13V11Z"}}]};

const MinusRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'minus-rectangle',
    ref,
    icon: element,
  },
));

MinusRectangleIcon.displayName = 'MinusRectangleIcon';

export default MinusRectangleIcon;
